import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { getActivityTemplateItemList } from '../../slices/thunks';


const useActivityTemplateItem = () => {
    const dispatch = useDispatch();

    const selector = createSelector(
        state => state.Activities,
        data => ({
            ActivityTemplateItemList: data.itemActivityTemplateItemList,
        })
    );

    const { ActivityTemplateItemList } = useSelector(selector);

    useEffect(() => {
        dispatch(getActivityTemplateItemList());
    }, [dispatch]);
    return { ActivityTemplateItemList };
}

export default useActivityTemplateItem;